import React from 'react'

import { GetCustomerCartQuery } from '../../graphql/magento'
import { coloradoDeliveryFee } from '../../utils/priceTools'
import CartSummaryRow from './CartSummaryRow'

export interface CartDeliveryFeeProps {
  cart: NonNullable<GetCustomerCartQuery['customerCart']>
  className?: string
}

const CartRetailDeliveryFee: React.FC<CartDeliveryFeeProps> = ({ cart, className }) => {
  const retailDeliveryFeeText = coloradoDeliveryFee(cart)
  return retailDeliveryFeeText ? (
    <CartSummaryRow className={className}>
      <div>Colorado Retail Delivery Fee:</div>
      <div>{retailDeliveryFeeText}</div>
    </CartSummaryRow>
  ) : null
}

export default CartRetailDeliveryFee
